import { useEffect, useState } from 'react';
import Content from '../Section/Content';
import { Header } from '../Section/Header';

const Theme = ({ attributes , setAttributes }) => {

    const { faqData = [] } = attributes || {};

    const [searchTerm, setSearchTerm] = useState("");
    const [activeCategory, setActiveCategory] = useState("all");
    const [filteredFaqs, setFilteredFaqs] = useState(faqData);

    useEffect(() => {
        let list = faqData || [];

        if (activeCategory && activeCategory !== "all") {
            list = list.filter((f) => f.categories === activeCategory);
        }

        if (searchTerm && searchTerm.trim() !== "") {
            const q = searchTerm.toLowerCase();
            list = list.filter(
                (f) =>
                    (f.question || "").toLowerCase().includes(q) ||
                    (f.answer || "").toLowerCase().includes(q)
            );
        }

        setFilteredFaqs(list);
    }, [faqData, activeCategory, searchTerm]);


    return (
        <div className='ThemeOneWrapper faq-container-style'>
            <section className='faa-section-main'>
                <Header
                    attributes={attributes}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                />
                <Content
                    faqs={filteredFaqs}
                    activeCategory={activeCategory}
                    attributes={attributes}
                    setAttributes={setAttributes}
                />
            </section>
        </div>
    )
}

export default Theme;